import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { ApiStatus } from "../../utils/api.types";
import { fetchSkuVariants, addSkuVariant, updateSkuVariant, deleteSkuVariant } from "./skuVariantThunk";

interface SkuVariantSliceState {
  variants: any[];
  status: ApiStatus;
  errorMessage?: string;
}

const initialState: SkuVariantSliceState = { variants: [], status: ApiStatus.IDLE, errorMessage: "" };

const skuVariantSlice = createSlice({
  name: "skuVariant",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch list (endpoint returns a plain array)
      .addCase(fetchSkuVariants.pending, (state) => {
        state.status = ApiStatus.LOADING;
      })
      .addCase(fetchSkuVariants.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        state.variants = Array.isArray(action.payload) ? action.payload : [];
        state.errorMessage = "";
      })
      .addCase(fetchSkuVariants.rejected, (state, action) => {
        state.status = ApiStatus.FAILED;
        state.errorMessage = action.error.message;
      })

      // Create
      .addCase(addSkuVariant.pending, (state) => {
        state.status = ApiStatus.LOADING;
      })
      .addCase(addSkuVariant.fulfilled, (state) => {
        state.status = ApiStatus.SUCCESS;
        toast.success("Variant set created successfully");
      })
      .addCase(addSkuVariant.rejected, (state, action) => {
        state.status = ApiStatus.FAILED;
        toast.error(action.error.message || "Failed to create variant set");
      })

      // Update
      .addCase(updateSkuVariant.pending, (state) => {
        state.status = ApiStatus.LOADING;
      })
      .addCase(updateSkuVariant.fulfilled, (state) => {
        state.status = ApiStatus.SUCCESS;
        toast.success("Variant set updated successfully");
      })
      .addCase(updateSkuVariant.rejected, (state, action) => {
        state.status = ApiStatus.FAILED;
        toast.error(action.error.message || "Failed to update variant set");
      })

      // Delete
      .addCase(deleteSkuVariant.fulfilled, () => {
        toast.success("Variant set deleted successfully");
      })
      .addCase(deleteSkuVariant.rejected, (_state, action) => {
        toast.error(action.error.message || "Failed to delete variant set");
      });
  },
});

export default skuVariantSlice.reducer;
